import React, { Component } from 'react'
import { get } from "lodash"

import { checkIsValidSex } from "./static.sexData"
import { withStepsState } from "./../../../shared/containers/containerStepsState"
import ButtonFill from "./../../../shared/items/controls/buttonFill"


class SexNextStepButton extends Component {
  componentDidUpdate() {
    const { data, onSetSuccessValidate } = this.props

    if (checkIsValidSex(data))
      onSetSuccessValidate("sex")
  }

  render() {
    const { data, onToNextStep } = this.props

    return (
      <ButtonFill disabled={!get(data, ["sex", "isValid"], false)} onClick={onToNextStep}>
        {this.props.children}
      </ButtonFill>
    )
  }
}

export default withStepsState(SexNextStepButton)